import Rosary, { MysteryTypes } from '../data/rosary.js';
import Latin from '../data/latin.js';
import English from '../data/english.js';
import Polish from '../data/polish.js';

const getMysteryType = () => {
	const date = new Date();
	const dayOfTheWeek = date.getDay();
	
	if (dayOfTheWeek === 1 || dayOfTheWeek === 6) return MysteryTypes.JOYFUL;
	if (dayOfTheWeek === 2 || dayOfTheWeek === 5) return MysteryTypes.SORROWFUL;
	if (dayOfTheWeek === 3 || dayOfTheWeek === 0) return MysteryTypes.GLORIOUS;
	if (dayOfTheWeek === 4) return MysteryTypes.LUMINOUS;
};

export const getPrayerFactory = (language = 'Latin') => index => {
	const prayerName = Rosary[index] || '';
	const Language = { Latin, English, Polish }[language];

	if (!prayerName.startsWith('MYSTERY')) {
		return Language.Prayers[prayerName] || '';
	}

	const mysteryType = getMysteryType();
	const ordinal = Language.Ordinals[prayerName];
	const mystery = Language.Mysteries[mysteryType][prayerName];

	return `${ordinal}: ${mystery}`;
};

export const getMeditationFactory = (meditations = 'None') => index => {
	if (meditations === 'None') return '';

	const prayerName = Rosary[index] || '';
	const Language = { English, Polish }[meditations];

	if (!prayerName.startsWith('MYSTERY')) {
		return '';
	}

	const mysteryType = getMysteryType();
	
	return Language.Meditations[mysteryType][prayerName];
};

export const rosaryLength = Rosary.length;
